/*!
 * 成長率標記：▲/▼ + 百分比（正綠負紅）
 * 顯示某數值「與上一期比較」的成長%。previous 缺/為 0 顯示「—」。
 */
import React from "react";
import { growthPct } from "./weekWindowUtils";

function GrowthBadge({ current, previous, pct: pctProp, size = "0.78em", style }) {
  const pct = pctProp !== undefined ? pctProp : growthPct(current, previous);
  if (pct === null || pct === undefined || Number.isNaN(pct)) {
    return <span style={{ color: "#9aa4bb", fontSize: size, ...style }}>—</span>;
  }
  const up = pct >= 0;
  return (
    <span
      style={{
        color: up ? "#00d6b4" : "#fd5d93",
        fontSize: size,
        fontWeight: 600,
        whiteSpace: "nowrap",
        ...style,
      }}
      title="與上一期比較"
    >
      {up ? "▲" : "▼"} {up ? "+" : ""}
      {pct.toFixed(1)}%
    </span>
  );
}

export default GrowthBadge;
